import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_PROJECT_REDUX]'; // eslint-disable-line

const functionDefinitions = {
    /*---------- projectList --------*/
    requestProjectList: null,
    projectListSuccess: ['projectListResponse'],
    projectListFailure: ['projectListError'],

    /*---------- projectDetail --------*/
    requestProjectDetail: ['projectId', 'activeTab'],
    projectDetailSuccess: ['projectDetailResponse'],
    projectDetailFailure: ['projectDetailError'],
    projectDetailProjectChanged: ['project2Change'],
    projectDetailAssetChanged: ['asset2Change'],
    projectDetailProjectTypesChanged: ['projectTypes2Change'],
    projectDetailProjectFeaturesChanged: ['projectFeatures2Change'],
    projectDetailProjectUnitsChanged: ['projectUnits2Change', 'projectUnitId'],
    projectDetailImageTitleChanged: ['title2Change', 'pictureId', 'pictureType'],

    /*---------- projectDetailImage --------*/

    requestProjectDetailImage: ['base64StrImage', 'projectId', 'type'],
    projectDetailImageSuccess: ['projectDetailImageResponse'],
    projectDetailImageFailure: ['projectDetailImageError'],

    /*---------- projectDeleteImage --------*/

    requestProjectDeleteImage: ['referenceId', 'projectImages2Delete', 'imageType', 'projectId'],
    projectDeleteImageSuccess: ['projectDeleteImageResponse'],
    projectDeleteImageFailure: ['projectDeleteImageError'],

    /*---------- projectMatrixBatch --------*/

    requestProjectMatrixBatch: ['branchId', 'culture'],
    projectMatrixBatchSuccess: ['projectMatrixBatchResponse'],
    projectMatrixBatchFailure: ['projectMatrixBatchError'],

    /*---------- projectUpdateBatch --------*/

    requestProjectUpdateBatch: ['projectId', 'actionName', 'percentage', 'salesState', 'salesAgentId', 'propertyList', 'defectList', 'price', 'markUnitIsPercent', 'userId'],
    projectUpdateBatchSuccess: ['projectUpdateBatchResponse'],
    projectUpdateBatchFailure: ['projectUpdateBatchError'],

    /*---------- initialProjectData --------*/

    requestInitialProjectData: [],
    initialProjectDataSuccess: ['initialProjectDataResponse'],
    initialProjectDataFailure: ['initialProjectDataError'],

    /*---------- createProject --------*/

    requestCreateProject: ['project', 'userId', 'isIFrame'],
    createProjectSuccess: ['createProjectResponse'],
    createProjectFailure: ['createProjectError'],

    /*---------- projectCreateProrjectProperty --------*/

    initialCreateProjectProperty: [],
    requestProjectCreateProrjectProperty: ['projectId', 'unitNumber', 'unitTypeId', 'price', 'minimumPrice', 'category'],
    projectCreateProrjectPropertySuccess: ['projectCreateProrjectPropertyResponse'],
    projectCreateProrjectPropertyFailure: ['projectCreateProrjectPropertyError'],

    /*---------- createProjectUnit --------*/

    requestCreateProjectUnit: ['projectId'],
    createProjectUnitSuccess: ['createProjectUnitResponse'],
    createProjectUnitFailure: ['createProjectUnitError'],

    /*---------- updateProject --------*/

    requestUpdateProject: ['project2Change', 'userId'],
    updateProjectSuccess: ['updateProjectResponse'],
    updateProjectFailure: ['updateProjectError'],

    /*---------- updateProjectUnits --------*/
    requestUpdateProjectUnits: ['projectUnits2Change', 'projectId'],
    updateProjectUnitsSuccess: ['updateProjectUnitsResponse'],
    updateProjectUnitsFailure: ['updateProjectUnitsError'],

    /*---------- deleteProject --------*/

    requestDeleteProject: ['projectId', 'isIFrame', 'userId'],
    deleteProjectSuccess: ['deleteProjectResponse'],
    deleteProjectFailure: ['deleteProjectError'],

    /*---------- deleteProjectUnit --------*/

    requestDeleteProjectUnit: ['projectId', 'projectUnitId'],
    deleteProjectUnitSuccess: ['deleteProjectUnitResponse'],
    deleteProjectUnitFailure: ['deleteProjectUnitError'],

    /*---------- generateProjectReport --------*/

    requestGenerateProjectReport: ['filter', 'exportType', 'projectId'],
    generateProjectReportSuccess: ['generateProjectReportResponse'],
    generateProjectReportFailure: ['generateProjectReportError'],

    /*---------- createProjectEnquiry --------*/

    initialCreateProjectEnquiry: [],
    requestCreateProjectEnquiry: ['projectEnquiry'],
    createProjectEnquirySuccess: ['createProjectEnquiryResponse'],
    createProjectEnquiryFailure: ['createProjectEnquiryError'],

    /*---------- advanceProjectSearch --------*/

    requestAdvanceProjectSearch: ['advansearch'],
    advanceProjectSearchSuccess: ['advanceProjectSearchResponse'],
    advanceProjectSearchFailure: ['advanceProjectSearchError'],


    /*---------- pageSize --------*/
    requestKeepPageSize: ['pageSize'],


    /*---------- MatrixView Sales  pageSize   --------*/
    requestKeepMatrixViewSalesPageSize: ['pageSize'],

    /*---------- MatrixView Construction  pageSize   --------*/
    requestKeepMatrixViewConstructionPageSize: ['pageSize'],

    /*---------- updateProjectSentToWeb --------*/
    requestUpdateProjectSentToWeb: ['isSentToWeb', 'projectId', 'userId'],
    updateProjectSentToWebSuccess: ['updateProjectSentToWebResponse'],
    updateProjectSentToWebFailure: ['updateProjectSentToWebError'],

    /*---------- updatePortalSenderForProject --------*/
    requestUpdatePortalSenderForProject: ['projectId', 'portalId', 'userId', 'isSelected'],
    updatePortalSenderForProjectSuccess: ['updatePortalSenderForProjectResponse'],
    updatePortalSenderForProjectFailure: ['updatePortalSenderForProjectError'],

    /*---------- getProjectPortals --------*/
    requestGetProjectPortals: ['projectId'],
    getProjectPortalsSuccess: ['getProjectPortalsResponse'],
    getProjectPortalsFailure: ['getProjectPortalsError'],
};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaProjectTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaProjectInitState = {
    projectList: [],
    projectDetail: []
};

export const INITIAL_STATE = Immutable(SagaProjectInitState);

/* ------------- Reducers ------------- */

/*---------- projectList --------*/
export const requestProjectList = (state) => {
    return state.merge({
        projectListFetching: true
    });
};
export const projectListSuccess = (
    state,
    action
) => {
    return state.merge({
        projectListFetching: false,
        projectListResponse: action.projectListResponse,
        projectListError: null // if success, then set error to be NULL
    });
};
export const projectListFailure = (
    state,
    action
) => {
    return state.merge({
        projectListFetching: false,
        projectListError: action.projectListError
        // do not set payload to be null, as it will cause your UI to go empty
    });
};

/*---------- projectDetail --------*/

export const requestProjectDetail = (state, action) => {
    return state.merge(
        {
            projectDetailFetching: true,
            projectId: action.projectId,
            activeTab: action.activeTab,
            projectDetailError: null,
            projectDetailResponse: null,
            updateProjectFetching: false,
            updateProjectError: null,
            updateProjectUnitsResponse: null,
            updateProjectUnitsError: null,
            generateProjectReportResponse: null,
            generateProjectReportError: null,
            createProjectEnquiryError: null,
            updateProjectSentToWebError: null,
            updateProjectSentToWebFetching: false
        });
};
export const projectDetailSuccess = (state, action) => {

    return state.merge(
        {
            projectDetailFetching: false,
            projectDetailResponse: action.projectDetailResponse,
            projectDetailError: null
        });
};
export const projectDetailFailure = (state, action) => {
    return state.merge(
        {
            projectDetailFetching: false,
            projectDetailError: action.projectDetailError

        });
};
export const projectDetailProjectChanged = (state, action) => {
    let project = state.projectDetailResponse.project;
    project = R.merge(project, action.project2Change);
    return state.merge({
        projectDetailResponse: R.merge(state.projectDetailResponse, { project })
    });
};
export const projectDetailAssetChanged = (state, action) => {
    let propertyAsset = state.projectDetailResponse.propertyAsset;
    propertyAsset = R.merge(propertyAsset, action.asset2Change);
    return state.merge({
        projectDetailResponse: R.merge(state.projectDetailResponse, { propertyAsset })
    });
};
export const projectDetailProjectTypesChanged = (state, action) => {
    const selectedProjectTypes = action.projectTypes2Change.selectedProjectTypes;
    return state.merge({
        projectDetailResponse: R.merge(state.projectDetailResponse, { selectedProjectTypes })
    });
};
export const projectDetailProjectFeaturesChanged = (state, action) => {
    const projectDetailResponse = Immutable.asMutable(state.projectDetailResponse, { deep: true });
    projectDetailResponse.features = action.projectFeatures2Change.features;
    return state.merge({ projectDetailResponse });
};
export const projectDetailProjectUnitsChanged = (state, action) => {
    let projectUnits = state.projectDetailResponse.projectUnits;
    let index = 0;
    let projectUnitsChanged = null;
    for (let i = 0; i <= projectUnits.length; i++) {
        if (projectUnits[i].projectUnit.id === action.projectUnitId) {
            index = i;
            projectUnitsChanged = projectUnits[i];
            break;
        }
    }
    if (projectUnitsChanged == null && !projectUnitsChanged) {
        return state;
    }
    const p1 = R.merge(projectUnitsChanged.projectUnit, action.projectUnits2Change);
    const p2 = R.merge(projectUnitsChanged, { projectUnit: p1 });
    projectUnits = R.merge(projectUnits, { [index]: p2 });
    // convert it back to array because when merge 'map' function it's not working anymore.
    projectUnits = Object.keys(projectUnits).map((i) => {
        return projectUnits[i];
    });
    return state.merge({
        projectDetailResponse: R.merge(state.projectDetailResponse, { projectUnits })
    });
};
export const projectDetailImageTitleChanged = (state, action) => {
    const pictureType = action.pictureType;
    const pictureId = action.pictureId;
    const title2Change = action.title2Change;

    console.log(pictureType, pictureId, title2Change);

    const projectDetailResponse = Immutable.asMutable(state.projectDetailResponse, { deep: true });
    const projectUnits = projectDetailResponse.projectUnits;
    let projectUnitIndex = -1;
    let pictureIndex = -1;

    if (!pictureType || pictureId == null || pictureId === 0) {
        return state;
    }

    switch (pictureType) {
        case 'project-gallery':
            // let pictures = state.projectDetailResponse.pictures;
            const index = R.findIndex(R.propEq('id', pictureId))(projectDetailResponse.pictures);
            console.log(projectDetailResponse.pictures[index]);
            projectDetailResponse.pictures[index].title = title2Change;
            return state.merge({ projectDetailResponse });
        case 'unit-floorplan':
            console.log('floorplan');
            for (let i = 0; i <= projectUnits.length; i++) {
                pictureIndex = R.findIndex(R.propEq('id', pictureId))(projectDetailResponse.projectUnits[i].floorPlanPictures);
                if (pictureIndex !== -1) {
                    projectUnitIndex = i;
                    break;
                }
            }
            if (projectUnitIndex === -1 || pictureIndex === -1) {
                break;
            }
            projectDetailResponse.projectUnits[projectUnitIndex].floorPlanPictures[pictureIndex].title = title2Change;
            return state.merge({ projectDetailResponse });
        case 'unit-gallery':
            console.log('galleryplan');
            for (let i = 0; i <= projectUnits.length; i++) {
                pictureIndex = R.findIndex(R.propEq('id', pictureId))(projectDetailResponse.projectUnits[i].galleryPictures);
                if (pictureIndex !== -1) {
                    projectUnitIndex = i;
                    break;
                }
            }
            if (projectUnitIndex === -1 || pictureIndex === -1) {
                break;
            }
            projectDetailResponse.projectUnits[projectUnitIndex].galleryPictures[pictureIndex].title = title2Change;
            return state.merge({ projectDetailResponse });
        default:
            break;
    }

    return state;
};


/*---------- projectDetailImage --------*/

export const requestProjectDetailImage = (state) => {
    return state.merge(
        {
            projectDetailImageFetching: true
        });
};
export const projectDetailImageSuccess = (state, action) => {
    return state.merge(
        {
            projectDetailImageFetching: false,
            projectDetailImageResponse: action.projectDetailImageResponse

        });
};
export const projectDetailImageFailure = (state, action) => {
    return state.merge(
        {
            projectDetailImageFetching: false,
            projectDetailImageError: action.projectDetailImageError

        });
};

/*---------- projectDeleteImage --------*/

export const requestProjectDeleteImage = (state, action) => {
    return state.merge(
        {
            projectDeleteImageFetching: true,
            referenceId: action.referenceId,
            projectImages2Delete: action.projectImages2Delete,
            imageType: action.imageType,
            projectId: action.projectId
        });
};
export const projectDeleteImageSuccess = (state, action) => {
    return state.merge(
        {
            projectDeleteImageFetching: false,
            projectDeleteImageResponse: action.projectDeleteImageResponse

        });
};
export const projectDeleteImageFailure = (state, action) => {
    return state.merge(
        {
            projectDeleteImageFetching: false,
            projectDeleteImageError: action.projectDeleteImageError

        });
};

/*---------- projectMatrixBatch --------*/

export const requestProjectMatrixBatch = (state) => {
    return state.merge({
        projectMatrixBatchFetching: true,
        projectMatrixBatchError: null
    });
};
export const projectMatrixBatchSuccess = (
    state,
    action
) => {
    return state.merge({
        projectMatrixBatchFetching: false,
        projectMatrixBatchResponse: action.projectMatrixBatchResponse
    });
};
export const projectMatrixBatchFailure = (
    state,
    action
) => {
    return state.merge({
        projectMatrixBatchFetching: false,
        projectMatrixBatchError: action.projectMatrixBatchError
    });
};

/*---------- projectUpdateBatch --------*/

export const requestProjectUpdateBatch = (state, action) => {
    return state.merge({
        projectUpdateBatchFetching: true,
        projectUpdateBatchError: null,
        projectId: action.projectId,
        actionName: action.actionName,
        percentage: action.percentage,
        salesState: action.salesState,
        salesAgentId: action.salesAgentId,
        propertyList: action.propertyList,
        defectList: action.defectList,
        price: action.price,
        markUnitIsPercent: action.markUnitIsPercent,
        userId: action.userId
    });
};
export const projectUpdateBatchSuccess = (state, action) => {
    return state.merge({
        projectUpdateBatchFetching: false,
        projectUpdateBatchResponse: action.projectUpdateBatchResponse,
        projectDetailResponse: action.projectUpdateBatchResponse,
    });
};
export const projectUpdateBatchFailure = (state, action) => {
    return state.merge({
        projectUpdateBatchFetching: false,
        projectUpdateBatchError: action.projectUpdateBatchError
    });
};

/*---------- projectCreateProrjectProperty --------*/

export const initialCreateProjectProperty = (state, action) => {
    return state.merge(
        {
            projectCreateProrjectPropertyFetching: false,
            projectCreateProrjectPropertyError: null
        });

};

export const requestProjectCreateProrjectProperty = (state, action) => {
    return state.merge(
        {
            projectCreateProrjectPropertyFetching: true,
            projectCreateProrjectPropertyError: null,
            projectid: action.projectId,
            unitNumber: action.unitNumber,
            unitTypeId: action.unitTypeId,
            price: action.price,
            minimumPrice: action.minimumPrice,
            category: action.category
        });
};
export const projectCreateProrjectPropertySuccess = (state, action) => {
    return state.merge(
        {
            projectCreateProrjectPropertyFetching: false,
            projectCreateProrjectPropertyResponse: action.projectCreateProrjectPropertyResponse

        });
};
export const projectCreateProrjectPropertyFailure = (state, action) => {
    return state.merge(
        {
            projectCreateProrjectPropertyFetching: false,
            projectCreateProrjectPropertyError: action.projectCreateProrjectPropertyError

        });
};

/*---------- createProjectUnit --------*/


export const requestCreateProjectUnit = (state, action) => {
    return state.merge(
        {
            createProjectUnitFetching: true,
            projectId: action.projectId,
            createProjectUnitError: null
        });
};
export const createProjectUnitSuccess = (state, action) => {
    return state.merge(
        {
            createProjectUnitFetching: false,
            createProjectUnitResponse: action.createProjectUnitResponse,
            createProjectUnitError: null
        });
};
export const createProjectUnitFailure = (state, action) => {
    return state.merge(
        {
            createProjectUnitFetching: false,
            createProjectUnitError: action.createProjectUnitError

        });
};


/*---------- initialProjectData --------*/

export const requestInitialProjectData = (state, action) => {
    return state.merge(
        {
            initialProjectDataFetching: true,
            initialProjectDataError: null,
            updateProjectFetching: false,
            updateProjectError: null,
            updateProjectSentToWebFetching: false
        });
};
export const initialProjectDataSuccess = (state, action) => {
    return state.merge(
        {
            initialProjectDataFetching: false,
            initialProjectDataResponse: action.initialProjectDataResponse
        });
};
export const initialProjectDataFailure = (state, action) => {
    return state.merge(
        {
            initialProjectDataFetching: false,
            initialProjectDataError: action.initialProjectDataError,
            updateProjectSentToWebFetching: false
        });
};

/*---------- createProject --------*/

export const requestCreateProject = (state, action) => {
    return state.merge(
        {
            updateProjectFetching: true,
            project: action.project,
            userId: action.userId,
            isIFrame: action.isIFrame,
            updateProjectError: null
        });
};
export const createProjectSuccess = (state, action) => {
    return state.merge(
        {
            updateProjectFetching: false,
            createProjectResponse: action.createProjectResponse
        });
};
export const createProjectFailure = (state, action) => {
    return state.merge(
        {
            updateProjectFetching: false,
            updateProjectError: action.updateProjectError
        });
};

/*---------- updateProject --------*/

export const requestUpdateProject = (state, action) => {
    return state.merge(
        {
            updateProjectFetching: true,
            project2Change: action.project2Change,
            userId: action.userId,
            updateProjectError: null
        });
};
export const updateProjectSuccess = (state, action) => {
    return state.merge(
        {
            updateProjectFetching: false,
            updateProjectResponse: action.updateProjectResponse,
            projectDetailResponse: action.updateProjectResponse
        });
};
export const updateProjectFailure = (state, action) => {
    return state.merge(
        {
            updateProjectFetching: false,
            updateProjectError: action.updateProjectError

        });
};

/*---------- updateProjectUnits --------*/

export const requestUpdateProjectUnits = (state, action) => {
    return state.merge(
        {
            updateProjectUnitsFetching: true,
            projectUnits2Change: action.projectUnits2Change,
            projectId: action.projectId,
            updateProjectUnitsError: null,
            updateProjectUnitsResponse: null
        });
};
export const updateProjectUnitsSuccess = (state, action) => {
    return state.merge(
        {
            updateProjectUnitsFetching: false,
            updateProjectUnitsResponse: action.updateProjectUnitsResponse,
            projectDetailResponse: action.updateProjectUnitsResponse
        });
};
export const updateProjectUnitsFailure = (state, action) => {
    return state.merge(
        {
            updateProjectUnitsFetching: false,
            updateProjectUnitsError: action.updateProjectUnitsError
        });
};

/*---------- deleteProject --------*/


export const requestDeleteProject = (state, action) => {
    return state.merge(
        {
            deleteProjectFetching: true,
            projectId: action.projectId,
            isIFrame: action.isIFrame,
            userId: action.userId,
            deleteProjectError: null
        });
};
export const deleteProjectSuccess = (state, action) => {
    return state.merge(
        {
            deleteProjectFetching: false,
            deleteProjectResponse: action.deleteProjectResponse

        });
};
export const deleteProjectFailure = (state, action) => {
    return state.merge(
        {
            deleteProjectFetching: false,
            deleteProjectError: action.deleteProjectError

        });
};

/*---------- deleteProjectUnit --------*/


export const requestDeleteProjectUnit = (state, action) => {
    return state.merge(
        {
            deleteProjectUnitFetching: true,
            projectId: action.projectId,
            projectUnitId: action.projectUnitId,
            deleteProjectUnitError: null
        });
};
export const deleteProjectUnitSuccess = (state, action) => {
    return state.merge(
        {
            deleteProjectUnitFetching: false,
            deleteProjectUnitResponse: action.deleteProjectUnitResponse

        });
};
export const deleteProjectUnitFailure = (state, action) => {
    return state.merge(
        {
            deleteProjectUnitFetching: false,
            deleteProjectUnitError: action.deleteProjectUnitError

        });
};

/*---------- generateProjectReport --------*/

export const requestGenerateProjectReport = (state, action) => {
    return state.merge(
        {
            generateProjectReportFetching: true,
            filter: action.filter,
            exportType: action.exportType,
            projectId: action.projectId,
            generateProjectReportResponse: null,
            generateProjectReportError: null
        });
};
export const generateProjectReportSuccess = (state, action) => {
    return state.merge(
        {
            generateProjectReportFetching: false,
            generateProjectReportResponse: action.generateProjectReportResponse

        });
};
export const generateProjectReportFailure = (state, action) => {
    return state.merge(
        {
            generateProjectReportFetching: false,
            generateProjectReportError: action.generateProjectReportError

        });
};

/*---------- Create Project Enquiry --------*/

export const initialCreateProjectEnquiry = (state, action) => {
    return state.merge(
        {
            createProjectEnquiryFetching: false,
            createProjectEnquiryError: null,
            createProjectEnquiryResponse: null
        });
};
export const requestCreateProjectEnquiry = (state, action) => {
    return state.merge(
        {
            createProjectEnquiryFetching: true,
            projectEnquiry: action.projectEnquiry,
            createProjectEnquiryError: null
        });
};
export const createProjectEnquirySuccess = (state, action) => {
    return state.merge(
        {
            createProjectEnquiryFetching: false,
            createProjectEnquiryResponse: action.createProjectEnquiryResponse,
            createProjectEnquiryError: null
        });
};
export const createProjectEnquiryFailure = (state, action) => {
    return state.merge(
        {
            createProjectEnquiryFetching: false,
            createProjectEnquiryError: action.createProjectEnquiryError,
            createProjectEnquiryResponse: false

        });
};

/* ------------- requestKeepPageSize ------------- */

export const requestKeepPageSize = (state, action) => {
    return state.merge(
        {
            keepPageSize: action.pageSize
        });
};

/* ------------- requestKeepMatrixViewSalesPageSize ------------- */

export const requestKeepMatrixViewSalesPageSize = (state, action) => {
    return state.merge(
        {
            keepMatrixViewSalesPageSize: action.pageSize
        });
};

/* ------------- requestKeepMatrixViewConstructionPageSize ------------- */
export const requestKeepMatrixViewConstructionPageSize = (state, action) => {
    return state.merge(
        {
            keepMatrixViewConstructionPageSize: action.pageSize
        });
};

/*---------- advanceProjectSearch --------*/


export const requestAdvanceProjectSearch = (state, action) => {
    return state.merge(
        {
            advanceProjectSearchFetching: true,
            advansearch: action.advansearch

        });
};
export const advanceProjectSearchSuccess = (state, action) => {
    return state.merge(
        {
            advanceProjectSearchFetching: false,
            advanceProjectSearchResponse: action.advanceProjectSearchResponse,
            advanceProjectSearchError: null

        });
};
export const advanceProjectSearchFailure = (state, action) => {
    return state.merge(
        {
            advanceProjectSearchFetching: false,
            advanceProjectSearchError: action.advanceProjectSearchError

        });
};

/*---------- updateProjectSentToWeb --------*/
export const requestUpdateProjectSentToWeb = (state, action) => {
    return state.merge(
        {
            updateProjectSentToWebFetching: true,
            isSentToWeb: action.isSentToWeb,
            projectId: action.projectId,
            userId: action.userId,
            updateProjectSentToWebResponse: null,
            updateProjectSentToWebError: null
        });
};
export const updateProjectSentToWebSuccess = (state, action) => {
    // const projectDetailResponse = { ...state.projectDetailResponse };
    // projectDetailResponse.sentToWeb = state.isSentToWeb;
    return state.merge(
        {
            updateProjectSentToWebFetching: false,
            updateProjectSentToWebResponse: action.updateProjectSentToWebResponse,
            projectDetailResponse: action.updateProjectSentToWebResponse,
        });
};
export const updateProjectSentToWebFailure = (state, action) => {
    return state.merge(
        {
            updateProjectSentToWebFetching: false,
            updateProjectSentToWebError: action.updateProjectSentToWebError,
        });
};

/*---------- updatePortalSenderForProject --------*/
export const requestUpdatePortalSenderForProject = (state, action) => {
    return state.merge(
        {
            updatePortalSenderForProjectFetching: true,
            projectId: action.projectId,
            portalId: action.portalId,
            userId: action.userId,
            isSelected: action.isSelected
        });
};
export const updatePortalSenderForProjectSuccess = (state, action) => {
    const projectDetailResponse = (state.projectDetailResponse) ? Immutable.asMutable(state.projectDetailResponse, { deep: true }) : null;
    if (projectDetailResponse && state.portalId) {
        // update isInProgress, isSelected by portalId
        const index = R.findIndex(R.propEq('id', state.portalId))(projectDetailResponse.portals);
        if (index > -1) {
            projectDetailResponse.portals[index].isInProgress = true;
            projectDetailResponse.portals[index].isSelected = state.isSelected;
        }
    }
    return state.merge(
        {
            updatePortalSenderForProjectFetching: false,
            updatePortalSenderForProjectResponse: action.updatePortalSenderForProjectResponse,
            projectDetailResponse
        });
};
export const updatePortalSenderForProjectFailure = (state, action) => {
    return state.merge(
        {
            updatePortalSenderForProjectFetching: false,
            updatePortalSenderForProjectError: action.updatePortalSenderForProjectError,
        });
};

/*---------- getProjectPortals --------*/
export const requestGetProjectPortals = (state, action) => {
    return state.merge(
        {
            getProjectPortalsFetching: true,
            projectId: action.projectId,
            getProjectPortalsResponse: null
        });
};
export const getProjectPortalsSuccess = (state, action) => {
    const projectDetailResponse = Immutable.asMutable(state.projectDetailResponse, { deep: true });
    if(projectDetailResponse && projectDetailResponse !== undefined) {
        projectDetailResponse.portals = action.getProjectPortalsResponse;
    }
    return state.merge(
        {
            getProjectPortalsFetching: false,
            getProjectPortalsResponse: action.getProjectPortalsResponse,
            projectDetailResponse
        });
};
export const getProjectPortalsFailure = (state, action) => {
    return state.merge(
        {
            getProjectPortalsFetching: false,
            getProjectPortalsError: action.getProjectPortalsError
        });
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    /*---------- projectList --------*/
    [Types.REQUEST_PROJECT_LIST]: requestProjectList,
    [Types.PROJECT_LIST_SUCCESS]: projectListSuccess,
    [Types.PROJECT_LIST_FAILURE]: projectListFailure,

    /*---------- projectDetail --------*/

    [Types.REQUEST_PROJECT_DETAIL]: requestProjectDetail,
    [Types.PROJECT_DETAIL_SUCCESS]: projectDetailSuccess,
    [Types.PROJECT_DETAIL_FAILURE]: projectDetailFailure,
    [Types.PROJECT_DETAIL_PROJECT_CHANGED]: projectDetailProjectChanged,
    [Types.PROJECT_DETAIL_ASSET_CHANGED]: projectDetailAssetChanged,
    [Types.PROJECT_DETAIL_PROJECT_TYPES_CHANGED]: projectDetailProjectTypesChanged,
    [Types.PROJECT_DETAIL_PROJECT_FEATURES_CHANGED]: projectDetailProjectFeaturesChanged,
    [Types.PROJECT_DETAIL_PROJECT_UNITS_CHANGED]: projectDetailProjectUnitsChanged,
    [Types.PROJECT_DETAIL_IMAGE_TITLE_CHANGED]: projectDetailImageTitleChanged,

    /*---------- projectDetailImage --------*/

    [Types.REQUEST_PROJECT_DETAIL_IMAGE]: requestProjectDetailImage,
    [Types.PROJECT_DETAIL_IMAGE_SUCCESS]: projectDetailImageSuccess,
    [Types.PROJECT_DETAIL_IMAGE_FAILURE]: projectDetailImageFailure,

    /*---------- projectDeleteImage --------*/

    [Types.REQUEST_PROJECT_DELETE_IMAGE]: requestProjectDeleteImage,
    [Types.PROJECT_DELETE_IMAGE_SUCCESS]: projectDeleteImageSuccess,
    [Types.PROJECT_DELETE_IMAGE_FAILURE]: projectDeleteImageFailure,

    /*---------- projectMatrixBatch --------*/

    [Types.REQUEST_PROJECT_MATRIX_BATCH]: requestProjectMatrixBatch,
    [Types.PROJECT_MATRIX_BATCH_SUCCESS]: projectMatrixBatchSuccess,
    [Types.PROJECT_MATRIX_BATCH_FAILURE]: projectMatrixBatchFailure,

    /*---------- projectUpdateBatch --------*/

    [Types.REQUEST_PROJECT_UPDATE_BATCH]: requestProjectUpdateBatch,
    [Types.PROJECT_UPDATE_BATCH_SUCCESS]: projectUpdateBatchSuccess,
    [Types.PROJECT_UPDATE_BATCH_FAILURE]: projectUpdateBatchFailure,

    /*---------- initialProjectData --------*/

    [Types.REQUEST_INITIAL_PROJECT_DATA]: requestInitialProjectData,
    [Types.INITIAL_PROJECT_DATA_SUCCESS]: initialProjectDataSuccess,
    [Types.INITIAL_PROJECT_DATA_FAILURE]: initialProjectDataFailure,

    /*---------- createProject --------*/

    [Types.REQUEST_CREATE_PROJECT]: requestCreateProject,
    [Types.CREATE_PROJECT_SUCCESS]: createProjectSuccess,
    [Types.CREATE_PROJECT_FAILURE]: createProjectFailure,

    /*---------- projectCreateProrjectProperty --------*/

    [Types.INITIAL_CREATE_PROJECT_PROPERTY]: initialCreateProjectProperty,
    [Types.REQUEST_PROJECT_CREATE_PRORJECT_PROPERTY]: requestProjectCreateProrjectProperty,
    [Types.PROJECT_CREATE_PRORJECT_PROPERTY_SUCCESS]: projectCreateProrjectPropertySuccess,
    [Types.PROJECT_CREATE_PRORJECT_PROPERTY_FAILURE]: projectCreateProrjectPropertyFailure,

    /*---------- createProjectUnit --------*/

    [Types.REQUEST_CREATE_PROJECT_UNIT]: requestCreateProjectUnit,
    [Types.CREATE_PROJECT_UNIT_SUCCESS]: createProjectUnitSuccess,
    [Types.CREATE_PROJECT_UNIT_FAILURE]: createProjectUnitFailure,

    /*---------- updateProject --------*/

    [Types.REQUEST_UPDATE_PROJECT]: requestUpdateProject,
    [Types.UPDATE_PROJECT_SUCCESS]: updateProjectSuccess,
    [Types.UPDATE_PROJECT_FAILURE]: updateProjectFailure,

    /*---------- updateProjectUnits --------*/

    [Types.REQUEST_UPDATE_PROJECT_UNITS]: requestUpdateProjectUnits,
    [Types.UPDATE_PROJECT_UNITS_SUCCESS]: updateProjectUnitsSuccess,
    [Types.UPDATE_PROJECT_UNITS_FAILURE]: updateProjectUnitsFailure,

    /*---------- deleteProject --------*/

    [Types.REQUEST_DELETE_PROJECT]: requestDeleteProject,
    [Types.DELETE_PROJECT_SUCCESS]: deleteProjectSuccess,
    [Types.DELETE_PROJECT_FAILURE]: deleteProjectFailure,

    /*---------- deleteProjectUnit --------*/

    [Types.REQUEST_DELETE_PROJECT_UNIT]: requestDeleteProjectUnit,
    [Types.DELETE_PROJECT_UNIT_SUCCESS]: deleteProjectUnitSuccess,
    [Types.DELETE_PROJECT_UNIT_FAILURE]: deleteProjectUnitFailure,

    /*---------- generateProjectReport --------*/

    [Types.REQUEST_GENERATE_PROJECT_REPORT]: requestGenerateProjectReport,
    [Types.GENERATE_PROJECT_REPORT_SUCCESS]: generateProjectReportSuccess,
    [Types.GENERATE_PROJECT_REPORT_FAILURE]: generateProjectReportFailure,

    /*---------- createProjectEnquiry --------*/
    [Types.INITIAL_CREATE_PROJECT_ENQUIRY]: initialCreateProjectEnquiry,
    [Types.REQUEST_CREATE_PROJECT_ENQUIRY]: requestCreateProjectEnquiry,
    [Types.CREATE_PROJECT_ENQUIRY_SUCCESS]: createProjectEnquirySuccess,
    [Types.CREATE_PROJECT_ENQUIRY_FAILURE]: createProjectEnquiryFailure,

    /*---------- requestKeepPageSize --------*/
    [Types.REQUEST_KEEP_PAGE_SIZE]: requestKeepPageSize,

    /*---------- requestKeepMatrixViewSalesPageSize --------*/
    [Types.REQUEST_KEEP_MATRIX_VIEW_SALES_PAGE_SIZE]: requestKeepMatrixViewSalesPageSize,

    /*---------- requestKeepMatrixViewConstructionPageSize --------*/
    [Types.REQUEST_KEEP_MATRIX_VIEW_CONSTRUCTION_PAGE_SIZE]: requestKeepMatrixViewConstructionPageSize,

    /*---------- advanceProjectSearch --------*/

    [Types.REQUEST_ADVANCE_PROJECT_SEARCH]: requestAdvanceProjectSearch,
    [Types.ADVANCE_PROJECT_SEARCH_SUCCESS]: advanceProjectSearchSuccess,
    [Types.ADVANCE_PROJECT_SEARCH_FAILURE]: advanceProjectSearchFailure,

    /*---------- updateProjectSentToWeb --------*/
    [Types.REQUEST_UPDATE_PROJECT_SENT_TO_WEB]: requestUpdateProjectSentToWeb,
    [Types.UPDATE_PROJECT_SENT_TO_WEB_SUCCESS]: updateProjectSentToWebSuccess,
    [Types.UPDATE_PROJECT_SENT_TO_WEB_FAILURE]: updateProjectSentToWebFailure,

    /*---------- updatePortalSenderForProject --------*/
    [Types.REQUEST_UPDATE_PORTAL_SENDER_FOR_PROJECT]: requestUpdatePortalSenderForProject,
    [Types.UPDATE_PORTAL_SENDER_FOR_PROJECT_SUCCESS]: updatePortalSenderForProjectSuccess,
    [Types.UPDATE_PORTAL_SENDER_FOR_PROJECT_FAILURE]: updatePortalSenderForProjectFailure,

    /*---------- getProjectPortals --------*/
    [Types.REQUEST_GET_PROJECT_PORTALS]: requestGetProjectPortals,
    [Types.GET_PROJECT_PORTALS_SUCCESS]: getProjectPortalsSuccess,
    [Types.GET_PROJECT_PORTALS_FAILURE]: getProjectPortalsFailure,

});



// WEBPACK FOOTER //
// ./src/redux/sagaProject/sagaProjectRedux.ts